import { Box, Container, Heading } from '@hover/blueprint';
import React from 'react';
import LogoSlider from './LogoSlider';

const TrustedSection: React.FC = () => (
  <Container
    maxW="1200px"
    mt={1000}
    overflow="hidden"
    flexDir="column"
    alignItems="center"
  >
    <Container maxW="5xl" overflow="hidden" mb="52px">
      <Box flexDir="column" alignItems="center">
        <Heading
          maxW="5xl"
          size={{ base: 500, tablet: 700 }}
          color="neutral.700"
          textAlign="center"
          isLight
          style={{ marginBottom: 24 }}
        >
          Chosen by the names you trust in home protection and restoration
        </Heading>
        <Heading
          size={{ base: 300, tablet: 500 }}
          color="neutral.700"
          textAlign="center"
          isDisplay
          style={{ marginBottom: 0 }}
        >
          HOVER is trusted by thousands of names from home improvement
          contractors, to materials manufacturers, distributors, and insurers.
        </Heading>
      </Box>
    </Container>
    <LogoSlider />
  </Container>
);

export default TrustedSection;
